import styled from '@emotion/styled'
import { colors } from 'ic-snacks'
import ShiftRowCurrentHourBar from './ShiftRowCurrentHourBar'

interface Props {
  renderMarker: boolean
}

const ShiftRowCurrentBarMarker = styled(ShiftRowCurrentHourBar)<Props>(({ renderMarker }) => ({
  '&:before': renderMarker && {
    content: '""',
    position: 'absolute',
    width: 0,
    height: 0,
    borderLeft: '6px solid transparent',
    borderRight: '6px solid transparent',
    borderTop: `6px solid ${colors.RED_600}`,
    left: '50%',
    transform: 'translateX(-50%)',
  },
}))
export default ShiftRowCurrentBarMarker
